// extracted by mini-css-extract-plugin
export default {"button":"button_button__X9kjH","primary":"button_primary__iJ+PA","secondary":"button_secondary__xbQsy","ghost":"button_ghost__KmQaa"};